import * as React from 'react';
import { Text, Heading } from '@/hen-ui/atomics';
import { Flex } from '@/hen-ui/composites';

export interface ProgressFieldWrapperProps extends React.PropsWithChildren {
  /** Left-aligned label text (when provided, used for aria-labelledby on progress bar) */
  label?: string;
  /** Right-aligned value text (e.g. "75%") */
  valueLabel?: string;
  /** Id for the label element; when provided with label, progress bar uses aria-labelledby for WCAG */
}

/**
 * Field-style wrapper for Progress: when label or valueLabel is provided,
 * renders a header row (left-aligned label, right-aligned value) above the progress bar
 * using EDU Design System typography tokens. When both are omitted, renders only children.
 */
export const ProgressFieldWrapper: React.FC<ProgressFieldWrapperProps> = ({
  children,
  label,
  valueLabel,
}) => {
  if (!label && !valueLabel) return <>{children}</>;
  return (
    <Flex>
      <Flex direction='row'>
        {label != null && (
          <Heading color='subtext' className='font-bold' variant='h6'>
            {label}{' '}
          </Heading>
        )}
        {valueLabel != null && (
          <Text className='flex-1' color='subtext' variant='b5' align='right'>
            {valueLabel}{' '}
          </Text>
        )}
      </Flex>
      {children}
    </Flex>
  );
};
